import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { z } from 'zod';

const schema = z.object({
  message: z.string(),
  publicKey: z.string(),
  salt: z.string(),
});

type Schema = z.infer<typeof schema>;

function fetchPrivateKey({
  initData,
  publicKey,
}: {
  publicKey: string;
  initData: string;
}): Promise<void | Schema> {
  return fetch(
    new URL(
      '/telegram-bot/telegram/delegate-signer',
      import.meta.env.VITE_TELEGRAM_BOT_URL,
    ).toString(),
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        publicKey,
        initData,
      }),
    },
  )
    .then((response) => response.json())
    .then((data) => schema.parse(data))
    .catch(console.log);
}

export function useDelegatePrivateKeyQuery({
  initData,
  publicKey,
}: {
  initData: string;
  publicKey: string;
}): UseQueryResult<Schema> {
  return useQuery({
    queryKey: ['delegate_key', publicKey],
    queryFn: () =>
      fetchPrivateKey({
        publicKey,
        initData,
      }),
    retry: 3,
    enabled: Boolean(initData),
    staleTime: Infinity,
  });
}
